import axiosInstance from './axiosInstance';

let isRefreshing = false;
let failedQueue = [];
let isInitialLoad = true;
let refreshInterval;

const scheduleRefresh = () => {
  clearTimeout(refreshInterval);
  const data = JSON.parse(localStorage.getItem('data') || '{}');
  const expiry = data.expires_at || Date.now() + 3600000;
  const timeToRefresh = expiry - Date.now() - 600000;

  if (timeToRefresh > 0) {
    refreshInterval = setTimeout(async () => {
      const refreshed = await attemptRefresh();
      if (refreshed) {
        scheduleRefresh();
      }
    }, timeToRefresh);
  }
};

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export const attemptRefresh = async () => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then(() => true).catch(() => false);
  }

  isRefreshing = true;

  try {
    const token = localStorage.getItem('token');
    if (!token) return false;

    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const refreshRes = await axiosInstance.post('/auth/refresh');
    const newToken = refreshRes.data.access_token;

    localStorage.setItem('token', newToken);
    localStorage.setItem('data', JSON.stringify(refreshRes.data.data));
    const oldProfile = JSON.parse(localStorage.getItem('profile') || '{}');
    localStorage.setItem('profile', JSON.stringify(refreshRes.data.profile || oldProfile));

    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

    processQueue(null, newToken);
    return true;
  } catch (refreshErr) {
    console.warn('Token refresh failed:', refreshErr.response?.data);
    processQueue(refreshErr, null);
    if (refreshErr.response?.data?.requires_relogin) {
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      localStorage.removeItem('data');
      window.location.href = '/';
    }
    return false;
  } finally {
    isRefreshing = false;
  }
};

export const startRefreshTimer = () => {
  const token = localStorage.getItem('token');
  if (token && !isInitialLoad) {
    scheduleRefresh();
  }

  setTimeout(() => { isInitialLoad = false; }, 1000);

  return () => clearTimeout(refreshInterval);
};

